/** Run mode's address (2.E deliverable 4): `?item=<id>`, the selected run-sheet item. */
export interface RunSearch {
  readonly item?: string;
}

/** Keeps a non-empty `item` and drops everything else. */
export function parseRunSearch(raw: Record<string, unknown>): RunSearch {
  return typeof raw.item === 'string' && raw.item !== '' ? { item: raw.item } : {};
}
